import React, { useEffect, useState } from "react";

interface UneedBadgeProps {
  className?: string;
}

export const UneedBadge: React.FC<UneedBadgeProps> = ({ className = "" }) => {
  const [isDark, setIsDark] = useState<boolean>(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    setIsDark(mediaQuery.matches);

    const handleChange = (e: MediaQueryListEvent) => {
      setIsDark(e.matches);
    };

    mediaQuery.addEventListener("change", handleChange);
    return () => mediaQuery.removeEventListener("change", handleChange);
  }, []);

  const badgeUrl = isDark
    ? "https://www.uneed.best/EMBED1B.png"
    : "https://www.uneed.best/EMBED1A.png";

  return (
    <a
      href="https://www.uneed.best/tool/seo-ai-pal"
      target="_blank"
      rel="noopener"
      className={className}
    >
      <img
        src={badgeUrl}
        alt="Uneed badge"
        width={125}
        height={40}
        className="transition-opacity hover:opacity-90"
      />
    </a>
  );
};

export default UneedBadge;
